export default __webpack_public_path__ + "static/media/searchWhite.72aaaf28.svg";